import moment from 'moment'

export const taskDetail = {
  id: '',
  cparNo: '',
  department: '',
  name: '',
  date: moment().format('YYYY-MM-DD'),
  areaObserve: '',
  PIC: '',
  DIC: '',
  categoryObserve: '',
  problemDetail: '',
  assignedTo: '',
  assignedToName: '',
  isHappenedBefore: false,
  problemAnalysis: '',
  correctiveAction: '',
  correctiveActionBy: '',
  correctiveActionDate: moment().format('YYYY-MM-DD'),
  preventionAction: '',
  preventionActionBy: '',
  preventionActionDate: moment().format('YYYY-MM-DD'),
  remarkDetail: '',
  qboAdminRemark: '',
  ownerAreaRemark: '',
  evidence: '',
  remarkMachineRootCause: '',
  remarkManRootCause: '',
  remarkMaterialRootCause: '',
  remarkMethodRootCause: '',
  remarkEnvironmentRootCause: '',
  assignedToDateTime: moment().format('YYYY-MM-DD HH:mm:ss')
}

export const correctiveCorrectionAction = {
  id: '',
  questionListId: '',
  actionNo: '',
  rootCauseType: '',
  rootCauseRemark: '',
  actionType: '',
  actionRemark: '',
  workDescription: '',
  evidence: '',
  picId: '',
  targetDate: moment().format('YYYY-MM-DD HH:mm:ss'),
  createdBy: '',
  createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
  updatedBy: '',
  updatedAt: moment().format('YYYY-MM-DD HH:mm:ss')
}